<div fxLayout="row">
  <mat-form-field class="time-input-hour">
    <input matInput name="hour" type="number" max="24" min="-1" [formControl]="hoursFormControl" (blur)="emitTime()" (change)="handleOverflow()">
  </mat-form-field>
  <div class="time-input-simicolon">:</div>
  <mat-form-field class="time-input-minute">
    <input matInput name="minute" type="number" max="60" min="-1" [formControl]="minutesFormControl" (blur)="emitTime()" (change)="handleOverflow()">
  </mat-form-field>
</div>
